import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { ErrorMsg } from '../model/errorMsg';
import { ToastData } from '../model/toastData';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastsSubject = new BehaviorSubject<ToastData[]>([]);
  toastsState = this.toastsSubject.asObservable();

  showErrorToast(error: any, position: 'bottom-left' | 'bottom-center' = 'bottom-left', marginBottom?: boolean) {
    let toastErrorList: ErrorMsg[] = [];
    if (error && error.error && error.error.errorMsgs) {
      let errorList = error.error.errorMsgs;
      for (let key in errorList) {
        toastErrorList.push(errorList[key]);
      }
    }

    toastErrorList.forEach(errorMsg => {
      this.showErrToast(errorMsg, position, marginBottom);
    });
  }

  showErrToast(errorMsg: ErrorMsg, position: 'bottom-left' | 'bottom-center' = 'bottom-left', marginBottom?: boolean) {
    const currentToasts = this.toastsSubject.getValue();
    let index = currentToasts.length + 1;
    let translationParams = this.arrayToObject(errorMsg.args || []);
    const newToast: ToastData = { index, errorMsg, position, translationParams, marginBottom };
    this.toastsSubject.next([...this.toastsSubject.getValue(), newToast]);
  }

  showSucessErrorToast(toastData: ToastData[]) {
    this.toastsSubject.next(toastData);
  }

  updateToast(toastData: ToastData[]) {
    this.toastsSubject.next(this.resetIndex(toastData));
  }

  removeToastByIndex(index: number) {
    const currentToasts = this.toastsSubject.getValue();
    this.toastsSubject.next(currentToasts.splice(index, 1));
  }

  arrayToObject<T>(arr: T[]): { [key: number]: T } {
    return arr.reduce((acc, value, index) => {
      acc[index] = value;
      return acc;
    }, {} as { [key: number]: T });
  }

  resetIndex = (arr: any[]) => {
    return arr.map((item, newIndex) => ({
      ...item,
      index: newIndex + 1
    }));
  };
}
